/**
 * Created by Pankaj on 29-nov-2019
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {TimelineLite, TweenLite} from "gsap";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GuiDefaults} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaults";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {Utils} from "../../Utils/Utils";
import {RomanEmpire} from "../../RomanEmpire";

export class REGenieReSpinIntroView extends ScreenView {

    private _gfxContainer: PIXI.Container;
    private _introText: PIXI.Text;
    private _introText1: PIXI.Text;
    private _bg: PIXI.Sprite;
    private _introSpine: PIXI.spine.Spine;
    private _introTimeline: TimelineLite;
    private _bgMusicTimer: any;


    constructor(config: IScreenViewConfig, autoClose?: boolean) {
        super(config, autoClose);
    }

    protected initAnimations(): void {
        super.initAnimations();
        this._button.visible = false;
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        const isUSJurisdiction: boolean = RomanEmpire.api.gameClientConfiguration.jurisdictionName[0] === "U" && RomanEmpire.api.gameClientConfiguration.jurisdictionName[1] === "S";
        this._introSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("introOutro"));
        let pos = Helper.getSymbolPositions(2, 1);
        this._introSpine.position.set(pos[0] + 280, pos[1] - 25);
        this._introSpine.visible = false;
        this._bg = new PIXI.Sprite(GameResources.getTextures("FS_Background")[0]);
        this._bg.anchor.set(0.5, 0.5);

        this._gfxContainer = new PIXI.Container();

        let x: number = GameConfig.instance.GAME_WIDTH * 0.5;
        let y: number = RomanEmpireGameConfig.instance.GAME_HEIGHT / 2;
        this._bg.position.set(x, y);

        const introTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fontFamily: "Open Sans",
            fontSize: "28px",
            fontWeight: "bold",
            fill: [
                "#fedc45",
                "#ca8d19",
            ],
            fillGradientStops: [
                0.57,
                1
            ],
            dropShadowColor: "#000000",
            dropShadow: true,
            dropShadowAngle: 90,
            dropShadowDistance: 6,
            stroke: "#000000",
            strokeThickness: 1,
            wordWrap: true,
            wordWrapWidth: 320
        });
        let introText: PIXI.Text = new PIXI.Text(Translation.translate("Increasing Wild multipliers for every spin."), introTextStyle);
        let introText1: PIXI.Text = new PIXI.Text(Translation.translate("Connect multipliers for even higher payout!"), introTextStyle);
        introText.anchor.set(0, 1);
        introText1.anchor.set(0, 0);
        this._introText = introText;
        this._introText1 = introText1;
        this._introText.visible = false;
        this._introText1.visible = false;
        this._gfxContainer.addChildAt(this._bg, 0);
        this._gfxContainer.addChild(this._introSpine, this._introText, this._introText1);

        this._introTimeline = new TimelineLite({
            paused: true, onComplete: () => {
                this._introText.visible = true;
                this._introText1.visible = true;
                this._button.visible = true;
            }
        });
        this._introTimeline.add(new SpineTween(this._introSpine, 0, isUSJurisdiction?"intro_US_animation":"intro_animation"), 0);
        // this._introTimeline.add(() => {
        //     SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 2000, 0);
        // }, 0.1);
        this._introTimeline.add(() => SoundManager.playFSMusicIntro(), 1.3);


        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        this._introText.position.x = resizeData.width * 0.5 - 55;
        this._introText1.position.x = resizeData.width * 0.5 - 55;
        this._bg.position.set(resizeData.width * 0.5, resizeData.height * 0.5);
        this._introText.y = this._screenHeight * 0.5 - 10;
        this._introText1.y = this._screenHeight * 0.5 + 10;
    }

    // private startFSSound(){
    //     SoundManager.playSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN,undefined, 0);
    // }

    protected startPresentation(data?: ParsedServerData, onShowComplete?: () => void): void {
        this._button.visible = false;
        this._introText.visible = false;
        this._introText1.visible = false;
        this._introSpine.visible = true;
        this._introTimeline.play(0);
        this.alpha = 0;
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 2000, 0);
        SoundManager.playFSIntro();
        this.resizeText();
        TweenLite.to(this, 0.2, {
            alpha: 1, onComplete: () => {
                // added this event to change Background
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: RomanEmpireGameMode.GENIE_RESPIN}));
                super.startPresentation(data, onShowComplete);
            }
        });

    }

    protected setButtonPosition(data: IResizeData): void {
        super.setButtonPosition(data);
        let buttonPosX = this._screenWidth * 0.5,
            buttonPosY = this._screenHeight * 0.89;

        if (data.orientation === Orientation.PORTRAIT) {
            // fix for 4:3 ratio
            if (data.height >= 950 && data.height <= 1000) {
                buttonPosY = this._screenHeight * 0.786;
            } else if (data.height >= 850 && data.height <= 900) {
                buttonPosY = this._screenHeight * 0.816;
            } else {
                buttonPosY = this._screenHeight * 0.85;
            }
        }
        //fix done for Continue button for Russian
        this._button.setSize(240, 82, 0.8);
        this._button.position.set(buttonPosX, buttonPosY);
    }


    protected stopPresentation(closeCallback?: () => void): void {
        this._introText.visible = false;
        this._introText1.visible = false;
        this._introSpine.visible = false;
        super.stopPresentation(closeCallback);
    }

    protected getScaledButtonTextStyle(): any {
        var style = this._config.buttonTextStyle ? this._config.buttonTextStyle : GuiDefaults.DEFAULT_LABEL_STYLE;
        if (!Number(style.fontSize)) {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        if (SlotGame.api.options.device === 'desktop') {
            style.fontSize = (style.fontSize as any) + 12;
        } else {
            style.fontSize = (style.fontSize as any) * this._deviceScale;

        }
        return style;
    }

    protected onResize(data: IResizeData): void {
        super.onResize(data);
        this._introSpine.position.set(data.width / 2, data.height / 2);
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
    }

    protected onButtonClick(): void {
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS_INTRO, 1024, 0);
        SoundManager.playFSStartSound();
        if (this._bgMusicTimer) {
            clearTimeout(this._bgMusicTimer);
        }
        this._bgMusicTimer = setTimeout(SoundManager.playFSBackgroundMusic, 1024);
        // TweenLite.killDelayedCallsTo(SoundManager.playFSBackgroundMusic);
        // TweenLite.delayedCall(1.024, () => SoundManager.playFSBackgroundMusic());

        // This will turn off Autoplay if in restricted jurisdiction
        if (SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        super.onButtonClick();
    }

    private resizeText() {
        this._introText.style.fontSize = 28;
        Utils.shrinkTextWidth("", this._introText, 340);
        this._introText1.style.fontSize = 28;
        Utils.shrinkTextWidth("", this._introText1, 345);
    }
}